/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
export interface defaultAvatarProps extends React.SVGAttributes<SVGElement> {
size?: string | number;
}
const defaultAvatar: React.FC<defaultAvatarProps> = ({size, ...props}) => (
  <svg viewBox="0 0 60 60" fill="currentColor" width={ size || "1em" } height={ size || "1em" } {...props}>
    <path d="M0,0V60H60V0ZM40.37,47A19.15,19.15,0,0,1,13.9,41.23l-.06-.09a1,1,0,0,1,1.74-1,17.15,17.15,0,0,0,28.85,0l.06-.09a1,1,0,0,1,1.62,1.17A19.15,19.15,0,0,1,40.37,47Zm-19.53-19a3.58,3.58,0,0,0-3.58,3.58,1,1,0,0,1-2,0,5.58,5.58,0,1,1,11.16,0,1,1,0,0,1-2,0h0A3.58,3.58,0,0,0,20.84,27.95Zm18.32,0a3.58,3.58,0,0,0-3.58,3.58,1,1,0,0,1-2,0,5.58,5.58,0,1,1,11.16,0,1,1,0,0,1-2,0h0A3.58,3.58,0,0,0,39.16,27.95Z"
    />
  </svg>
);
defaultAvatar.displayName = 'defaultAvatar';
export default defaultAvatar;
/* tslint:enable */
/* eslint-enable */
